export default function removeAllSlides() {
  const swiper = this;

  const slidesIndexes = [];
  for (let i = 0; i &lt; swiper.slides.length; i += 1) {
    slidesIndexes.push(i);
  }
  swiper.removeSlide(slidesIndexes);
}
